// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import confirmSaveModal from './confirm-save-modal';
import currentLanguageKey from './update-current-language';
import isSaved from './update-is-saved';
import nextLocation from './update-next-location';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        confirmSaveModal,
        currentLanguageKey,
        isSaved,
        nextLocation
    });



// WEBPACK FOOTER //
// ./src/user/shared/reducers/preferences.js